import { MutableRefObject, useEffect, useRef } from 'react'
import TrackingEvent from '../../tracking-event'
import { computeScrollPercentage } from '../../../../hooks/useScrollEventTracker'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackClickEvent } from '@src/telemetry/track'
import { TelemetryEventNames } from '@src/telemetry/telemetry-events.types'

const handlePropagatedEvent = (event: TrackingEvent) => {
  let eventType: TelemetryEventNames
  switch (event.trackingEventType) {
    case TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.CLICK:
      eventType = TELEMETRY_EVENT_NAMES.BUTTON_CLICK
      break
    case TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.VISIBLE:
      eventType = TELEMETRY_EVENT_NAMES.IS_VISIBLE

      break
  }
  if (eventType) {
    trackClickEvent(eventType, {
      trackInternal: true,
      action: eventType,
      value: true,
      context: {
        childToParentTrackingIds: event.trackingIds,
        contentContainerType: event.tracking_details.contentContainerType,
        contentContainerName: event.tracking_details.contentContainerName,
        is_in_first_fold: computeScrollPercentage() === 0,
        id: event.tracking_details.trackingId,
        elementPosition: event.tracking_details.elementPosition,
        displayTitle: event.tracking_details.displayTitle,
        trackingMetaData: event.tracking_details.trackingMetaData,
      },
    })
  }
}

const useTrackingEventCapturer = <E extends HTMLElement>() => {
  const elementRef: MutableRefObject<E | undefined> = useRef<E>()

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    element.addEventListener(TrackingEvent.TRACKING_EVENT_TYPE, handlePropagatedEvent as EventListener)

    return () => {
      element.removeEventListener(TrackingEvent.TRACKING_EVENT_TYPE, handlePropagatedEvent as EventListener)
    }
  }, [])
  return { elementRef }
}

export default useTrackingEventCapturer
